var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n-list',{attrs:{"value":"discounts","text":"折扣","fields":_vm.fields,"items":_vm.discounts}})}
var staticRenderFns = []

export { render, staticRenderFns }